import style_vars from '../StyleVariables';

const nav = document.getElementById('c-nav--sticky');

const init = () => {

  const nav_sentinal = document.getElementById('c-nav-sentinal');

  const handler = (entries) => {
    // entries is an array of observed dom nodes
    // we're only interested in the first one at [0]
    // because that's our #c-nav-sentinal node.

    if (!entries[0].isIntersecting) {
      nav.classList.remove('color-border-transparent');
      nav.classList.add('c-nav--border-on');
      nav.classList.add('c-nav--is-scrolled');
    }
    else {
      nav.classList.remove('c-nav--border-on');
      nav.classList.add('color-border-transparent');
      nav.classList.remove('c-nav--is-scrolled');
    }
  }

  // create the observer
  const observer = new window.IntersectionObserver(handler)
  // give the observer some dom nodes to keep an eye on
  observer.observe(nav_sentinal);
}

if (nav && window.matchMedia(`(min-width:${style_vars.bp_min['lg']})`).matches) init();